import { Component, Input } from '@angular/core';

/**
 * Generic stub for a Filters sub-section whose real controls ship in a separate ticket
 * (weight validation, date filter builder, tag rules). Swapping a real component in later
 * only means replacing the <app-filter-section-placeholder> tag — no page restructuring.
 */
@Component({
  selector: 'app-filter-section-placeholder',
  templateUrl: './filter-section-placeholder.component.html',
  styleUrls: ['./filter-section-placeholder.component.sass'],
})
export class FilterSectionPlaceholderComponent {
  @Input() title: string;
  @Input() description = 'Controls for this filter ship in a separate ticket.';
}
